import { Link } from 'react-router-dom';
import {
    Wrapper,
    LogoWrapper,
    Logo,
    LeftContentWrapper,
    RightContentWrapper,
    IconWrapper,
    VersionWrapper,
    LeftRotationInfoWrapper,
} from './PageHeader.styles';
import RotationInfo from './RotationInfo';
import SelectVesselHeader from './SelectVesselHeader';
import ConnectionStatusComponent from './connection-status/Connectionstatus';
import UserInfoComponent from './userInfo/UserInfo';
import { useContext } from 'react';
import AppsMenuComponent from './appsMenu/AppsMenu';
import { useAuthStore } from '../../context/AuthContext';
import getContext from '../../context/AppSettingsContext';
import RotationSyncMsg from './rotationSyncMsg/RotationSyncMsg';
import SettingsComponent from './settings/Settings';
import { RoleTypeEnum } from '../../enums/roleTypeEnum';
import ContactComponent from './contact/Contact';
import HelpComponent from './help/Help';
import PageHeaderVerificationComponent from './verification/PageHeaderVerification';
import PageHeaderStowageComponent from './stowage/PageHeaderStowage';
import { getEnvironment } from 'src/utils/environmentUtils';

const PageHeader = () => {
    const { loggedInUser } = useAuthStore();
    const appSettings = useContext(getContext());
    const { role } = useAuthStore();

    const environment = getEnvironment();

    const showShipUserVerificationHeader = (): boolean => {
        if (location.pathname === '/verification' && role.roleType === RoleTypeEnum.ShipUser) {
            return true;
        }
        return false;
    };

    const showDefaultHeader = (): boolean => {
        if (location.pathname !== '/verification') {
            return true;
        }
        return false;
    };

    const getLeftWrapperClassName = () => {
        if (location.pathname === '/verification') {
            return 'verification-header';
        } else if (location.pathname === '/stowage') {
            return 'stowage-header';
        }
        return '';
    };

    const isStowage = (): boolean => {
        if (location.pathname === '/stowage') {
            return true;
        }
        return false;
    };

    return (
        <Wrapper environment={environment}>
            <LeftContentWrapper className={getLeftWrapperClassName()}>
                <LeftRotationInfoWrapper>
                    <LogoWrapper>
                        <Link to="/report-events">
                            <h1>
                                Orca<span className="sub-header">Web</span>
                            </h1>
                            <Logo src="../../../assets/logos/orca.svg" />
                        </Link>
                        <VersionWrapper>v{appSettings?.releaseId}</VersionWrapper>
                    </LogoWrapper>

                    {showDefaultHeader() && showShipUserVerificationHeader && (
                        <>
                            <SelectVesselHeader />
                            {!isStowage() && <RotationInfo />}
                        </>
                    )}
                    <PageHeaderVerificationComponent />
                </LeftRotationInfoWrapper>
            </LeftContentWrapper>

            {isStowage() && <PageHeaderStowageComponent />}

            <RightContentWrapper>
                {loggedInUser && (
                    <>
                        {!isStowage() && (
                            <IconWrapper className="no-border">
                                <RotationSyncMsg />
                            </IconWrapper>
                        )}

                        <IconWrapper className="no-border">
                            <ConnectionStatusComponent />
                        </IconWrapper>
                        <IconWrapper>
                            <ContactComponent />
                            <HelpComponent />
                            <SettingsComponent />
                            <AppsMenuComponent />
                            <UserInfoComponent />
                        </IconWrapper>
                    </>
                )}
            </RightContentWrapper>
        </Wrapper>
    );
};

export default PageHeader;
